type OsDefaultSource = {
  os_racking_type?: number;
  default_project_mode?: any;
};

export default (source: OsDefaultSource = {}) => {
  const osConfig = {
    building_code: 2,
    wind_speed: 117,
    snow_load: 5,
    seismic_ss: 0.46,
    elevation: 5499,
    mean_recurrence_interval: 25,
    building_height: 15,
    roof_type: 5,
    parapet_height: 1,
    block_weight: 32,
    wind_exposure: 'B',
    building_length: 100,
    os_racking_type: source.os_racking_type || 25,
    mid_clamps_choices: 4,
    end_clamps_choices: 4,
    is_test: source.default_project_mode,
  };
  return osConfig;
};
